import { createFileRoute } from '@tanstack/react-router';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { MobileBookingNew } from '@/features/bookings/mobile/MobileBookingNew';
import { DesktopBookingNew } from '@/features/bookings/desktop/DesktopBookingNew';
import { parseBookingChoice, type BookingChoice } from '@/features/bookings/newBookingRouting';

interface NewBookingSearch { type?: BookingChoice }

export const Route = createFileRoute('/_app/bookings/new')({
  component: BookingNewPage,
  /**
   * `?type=room` (o `vehicle`, `train`, `flight`…) preseleziona la tipologia: serve ai link che
   * arrivano da un contesto già specializzato — es. «Prenota una sala». I nomi e i numeri di prima
   * (`?type=2`, `plane`) restano validi: li traduce `parseBookingChoice`.
   */
  validateSearch: (search: Record<string, unknown>): NewBookingSearch => {
    const type = parseBookingChoice(search.type);
    return type ? { type } : {};
  },
});

/** Form "Nuova prenotazione": mobile fullscreen vs pagina desktop. */
function BookingNewPage() {
  const isMobile = useIsMobileShell();
  const { type } = Route.useSearch();
  return isMobile ? <MobileBookingNew initialType={type} /> : <DesktopBookingNew initialType={type} />;
}
